import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/app/account/')({
  beforeLoad: () => {
    throw redirect({ to: '/app/account/dashboard' })
  },
})
